import { z } from 'zod';

// ---------------------------------------------------------------------------
// Individual favorite item
// ---------------------------------------------------------------------------
export const FavoriteItemSchema = z.object({
  itemId: z.string(),
  type: z.enum(['product', 'design']),
  isFavorite: z.boolean().optional(),
  name: z.string().optional(),
  image: z.string().optional(),
  price: z.number().nullable().optional(),
  comparePrice: z.number().nullable().optional(),
  model3dUrl: z.string().nullable().optional(),
  availability: z.string().optional(),
  isPersonalizable: z.boolean().optional(),
  itemAdditionalData: z.record(z.string(), z.unknown()).optional(),
});
export type FavoriteItem = z.infer<typeof FavoriteItemSchema>;

// ---------------------------------------------------------------------------
// Normalized map stored in React Query cache: { [itemId]: FavoriteItem }
// ---------------------------------------------------------------------------
export const FavoritesMapSchema = z.record(z.string(), FavoriteItemSchema);
export type FavoritesMap = z.infer<typeof FavoritesMapSchema>;

// ---------------------------------------------------------------------------
// Shape stored in the cache under ['favorites', customerId]
// ---------------------------------------------------------------------------
export const FavoritesStateSchema = z.object({
  products: FavoritesMapSchema,
  designs: FavoritesMapSchema,
});
export type FavoritesState = z.infer<typeof FavoritesStateSchema>;

// ---------------------------------------------------------------------------
// Toggle mutation payload
// ---------------------------------------------------------------------------
export const ToggleFavoritePayloadSchema = z.object({
  itemId: z.string(),
  isFavorite: z.boolean(),
  type: z.enum(['product', 'design']),
  itemAdditionalData: z
    .object({
      productImage: z.string().optional(),
      price: z.number().nullable().optional(),
      comparePrice: z.number().nullable().optional(),
      model3dUrl: z.string().nullable().optional(),
      availability: z.string().optional(),
      productName: z.string().optional(),
      image: z.string().optional(),
      name: z.string().optional(),
      isPersonalizable: z.boolean().optional(),
    })
    .and(z.record(z.string(), z.unknown()))
    .optional(),
});
export type ToggleFavoritePayload = z.infer<typeof ToggleFavoritePayloadSchema>;

// ---------------------------------------------------------------------------
// Toggle mutation response
// ---------------------------------------------------------------------------
export const ToggleFavoriteResponseSchema = z.object({
  itemId: z.string(),
  isFavorite: z.boolean(),
  type: z.enum(['product', 'design']),
  itemAdditionalData: z.record(z.string(), z.unknown()).optional(),
});
export type ToggleFavoriteResponse = z.infer<typeof ToggleFavoriteResponseSchema>;
